module.exports = __webpack_public_path__ + "static/media/Molecular_Genetics.fc9db9e8.JPG";